<template>
  <div>
    <u-loader v-if="isLoading" />
    <div
      v-for="(comment, index) in comments"
      v-else
      :key="index"
      class="col-11 commentWrapper"
    >
      <div v-if="editCommentId != comment.id">
        <div class="commentText">
          <p>{{ comment.text }}</p>
        </div>
        <div class="commentSignature mb-1">
          {{ comment.createdBy }} -
          {{ comment.created | moment("DD.MM.YYYY") }} - Version:
          {{ comment.originalVersionNumber }} / Edition:
          {{ comment.originalEditionId }}
          <template v-if="comment.createdBy == $GetCurrentUserName()">
            <button
              v-b-modal.deleteComment
              v-b-tooltip.hover
              class="btn btn-danger float-right smallActionButton"
              placement="bottom"
              title="Kommentar löschen"
              type="button"
              @click="commentToDelete = comment"
            >
              <i class="fas fa-trash-alt" />
            </button>
            <button
              v-b-tooltip.hover
              class="btn btn-primary float-right mr-1 smallActionButton"
              placement="bottom"
              title="Kommentar bearbeiten"
              type="button"
              @click="editCommentId = comment.id"
            >
              <i class="fas fa-edit" />
            </button>
          </template>
        </div>
      </div>
      <div v-else>
        <v-textarea
          v-model="comment.text"
          auto-grow
          label="Kommentar"
          rows="1"
        />
        <b-button
          v-show="!isLoading"
          class="mt-2"
          name="saveStrucuture"
          variant="success"
          @click="saveComment(comment)"
        >
          Speichern
        </b-button>
        <b-button
          v-show="!isLoading"
          class="mt-2 ml-2"
          name="loadStructure"
          variant="danger"
          @click="loadComments()"
        >
          Abbrechen
        </b-button>
      </div>
    </div>

    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      :property-mapping="errorPropertyMappings"
      class="col-12 my-4"
    />
    <div
      v-if="canUserEdit"
      class="col-12"
    >
      <button
        v-if="
          comments.filter((item) => {
            return item.id == 0;
          }).length > 0
        "
        v-b-tooltip.hover
        class="btn btn-success float-right actionButton"
        placement="bottom"
        title="Speichern sie zuerst den neu erstellten Kommentar"
        type="button"
      >
        <i class="fas fa-plus" />
      </button>
      <button
        v-else
        v-b-tooltip.hover
        class="btn btn-success float-right actionButton"
        placement="bottom"
        title="Neuer Kommentar erfassen"
        type="button"
        @click="addNewComment()"
      >
        <i class="fas fa-plus" />
      </button>
    </div>
    <b-modal
      id="deleteComment"
      ref="deleteComment"
      hide-footer
      no-fade
      title="Kommentar löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher das Sie diesen Kommentar löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteComment(commentToDelete)"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  GetComments,
  SaveComment,
  CreateComment,
  DeleteComment,
} from "@/services/minimum.wage.services/comments.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  mixins: [MinimumWageMixin],
  data() {
    return {
      isLoading: false,
      errorObject: null,
      comments: [],
      editCommentId: -1,
      commentToDelete: null,
    };
  },
  created() {
    this.loadComments();
  },

  methods: {
    hideModal() {
      this.$refs["deleteComment"].hide();
    },
    deleteComment(comment) {
      this.isLoading = true;
      this.errorObject = null;
      this.hideModal();

      DeleteComment(
        this.contractId,
        this.versionId,
        this.editionId,
        comment,
        (response) => {
          this.comments = response;
          this.loadComments();
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    loadComments() {
      this.isLoading = true;
      this.errorObject = null;
      this.editCommentId = -1;

      GetComments(
        this.contractId,
        this.versionId,
        this.editionId,
        (response) => {
          this.comments = response;
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    saveComment(comment) {
      this.isLoading = true;
      this.errorObject = null;

      if (comment.id != 0) {
        SaveComment(
          this.contractId,
          this.versionId,
          this.editionId,
          comment,
          (response) => {
            this.comments = response;
            this.loadComments();
          },
          (error) => {
            this.isLoading = false;
            this.errorObject = error;
          },
        );
      } else {
        CreateComment(
          this.contractId,
          this.versionId,
          this.editionId,
          comment,
          (response) => {
            this.comments = response;
            this.loadComments();
          },
          (error) => {
            this.isLoading = false;
            this.errorObject = error;
          },
        );
      }
    },
    addNewComment() {
      this.comments.push({
        id: 0,
        configurationId: 0,
        originalEditionId: 0,
        text: "",
        created: new Date().toISOString(),
        createdBy: this.$GetCurrentUserName(),
      });
      this.editCommentId = 0;
    },
  },
};
</script>

<style scoped>
.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}

.commentWrapper {
  padding: 10px 10px 5px 10px;
  margin-right: 10px;
  border-bottom: 1px solid #c3c3c3;
  margin-top: 10px;
}

.commentSignature {
  color: rgb(179, 179, 179);
  margin-top: 4px;
}
</style>
